/* ============================================================================
   The notification poll, shared.

   <SidebarNotifications/> owns the one 10s poll. Anything else that shows
   notifications (the new-project banner) listens for NOTIFICATIONS_EVENT
   instead of polling again, and asks for an early poll with
   refreshNotifications() after it marks something read, so the bell's count
   does not lag behind by up to 10s.

   The last list is kept here too, so a listener that mounts between polls
   (navigating to a page that shows the banner) has something to show at once.
   ========================================================================== */
export const NOTIFICATIONS_EVENT = "app:notifications";
export const NOTIFICATIONS_REFRESH_EVENT = "app:notifications-refresh";

let latest = [];

export const latestNotifications = () => latest;

export const publishNotifications = (list) => {
  latest = list;
  window.dispatchEvent(new CustomEvent(NOTIFICATIONS_EVENT, { detail: list }));
};

export const refreshNotifications = () => {
  window.dispatchEvent(new CustomEvent(NOTIFICATIONS_REFRESH_EVENT));
};
